import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-out-of-stock",
  "use": "icon-out-of-stock-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-out-of-stock\"><path d=\"M13.095 13.089c.32-.32.338-.847.03-1.154l-5.22-5.22 5.183-5.182a.84.84 0 0 0 .007-1.166.834.834 0 0 0-1.166.007L6.747 5.556 1.521.33C1.214.023.687.04.367.361.04.688.029 1.208.336 1.515l5.226 5.226L.38 11.923c-.314.315-.332.853-.013 1.172.313.313.857.301 1.172-.013L6.72 7.9l5.22 5.22c.307.307.827.296 1.154-.031Z\" fill=\"#FF8300\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol